import req from './axios.js' //引入封装好的axios
import config from '@/config/config.js';
//*****************************基础请求的头部和地址信息***************************
const path=config.apiPath
export const basePath = path;
//**********************************************************  头部的请求接口地址 start ***************************************//
//获取平台配置信息
export const getPlatConfigInfo = (params, callback) => req(path + "/amc/api/open/apply/platConfig", 'get', params, callback)
export const checkPhone = (params, callback) => req(path + '/amc/api/open/user/checkPhone', 'get', params, callback);
export const sendCodeToPhone = (params, callback) => req(path + '/mmc/api/open/msg/verificationCodeToPhone?phone=' + params.phone, 'post', params, callback);
export const phoneTokenLogin = (params, callback) => req(path + '/amc/phone/token?phone=' + params.phone + '&code=' + params.code, 'post', {}, callback);
export const getUserInfo = (params, callback) => req(path + '/amc/api/token/user/getUserInfo', 'get', params, callback);
export const getUserCompany = (params, callback) => req(path + '/amc/api/token/user/getUserCompany', 'get', params, callback);
export const getUserDept = (params, callback) => req(path + '/amc/api/token/companyDept/deptUserType', 'get', params, callback);
export const getStyleByCode = (params, callback) => req(path + '/plm/api/open/smp/getStyleByCode', 'get', params, callback);


//**********************************************************  首页 ***********************************************************//

//获取当前用户在该企业下可见的App应用菜单
// ?applyId=5
// 获取对应的应用APPlyId
export const companyApplyMyVisibilityApp = (params, callback) => req(path + '/amc/api/token/companyApplyVisibility/companyApplyMyVisibilityApp', 'get', params, callback);
// 获取应用菜单
export const myCompanyApplys = (params, callback) => req(path + '/amc/api/token/user/getUserCompanyApplyMenu', 'get', params, callback);
export const myCompanyApplysPC = (params, callback) => req(path + '/amc/api/token/user/getUserCompanyApplyMenu?applyId=4', 'get', params, callback);
//**********************************************************  登录 ***********************************************************//
//获取字典集合
export const getDictPageList = (params, callback) => req(path + '/ccm/api/saas/basicBaseDicts/selectDictPageList', 'get', params, callback)
//*************************************
//密码加盐
export const checkPwd = (params, callback) => req(path + '/amc/api/open/user/checkPwd', 'get', params, callback);
//登录
export const uniLogin = (params, callback) => req(path + '/amc/password/token?username=' + params.username + '&password=' + params.password, 'post', params, callback);
//获取钉钉用户
export const getdingDingUserId = (params, callback) => req(path + '/amc/api/open/ding/getdingDingUserId', 'get', params, callback);
//自动登录
export const dingLogin = (params, callback) => req(path + '/amc/dingCode/token?userId=' + params.jobNumber + '&accessToken=' + params.accessToken, 'post', params, callback);
//获取corpId
export const getCorpId = (params, callback) => req(path + '/amc/api/open/ding/getCorpId', 'get', params, callback);


//*********************************************************  制单管理  *******************************************************//
//制造单查询
export const getDlorder = (params, callback) => req(path + '/mes/api/saas/dl/order', 'get', params, callback);
// 新增汇报
export const addOrderNodeReport = (params, callback) => req('/mes/api/saas/dl/orderNodeReport', 'post', params, callback);
// 根据当前用户ID和节点类型查询节点列表
export const getForReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNode/getForReport', 'get', params, callback);
//根据制造单id查出完整数据
export const getOrder = (params, callback) => req(path + '/mes/api/saas/dl/order/' + params, 'get', null, callback);
//根据唯一值查出完整数据
export const getByOrderCode = (params, callback) => req(path + '/mes/api/saas/dl/order/getByOrderCode', 'get', params, callback);
//保存数据
export const saveOrderNodeReport = (params, callback) => req(path +'/mes/api/saas/dl/orderNodeReport', 'post', params, callback);
// 上传附件
export const uploadMesPic = (params, callback) => req(path + '/mes/api/saas/upload/mesPic', 'post', params, callback);

//*********************************************************  制单进度  *******************************************************//
//查询节点汇报详情
export const getOrderNodeByPage = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/getOrderNodeByPage', 'get', params, callback);
export const queryOrderNumAsColorSize = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/queryOrderNumAsColorSize', 'get', params, callback);


//*********************************************************  扫菲报工  *******************************************************//
// 计划查询
export const getNodePlan = (params, callback) => req(path + '/mes/api/saas/dl/order/nodePlan', 'get', params, callback);
// 根据当前用户ID查询节点列表
export const getOrderNode = (params, callback) => req(path + '/mes/api/saas/dl/orderNode', 'get', params, callback);
// 根据当前用户ID和节点id查询节点
export const getByOrderNode = (params, callback) => req(path + '/mes/api/saas/dl/orderNode/' + params, 'get', null, callback);
//查询节点的排程排位工序
export const getNodeStationProcedure = (params, callback) => req(path + '/mes/api/saas/layoutVersionStation/getNodeStationProcedure', 'get', params, callback);
//获取上一节点汇报总数和当前节点工序汇报数量
export const getQueryOrderNodeSituation = (params, callback) => req(path + '/mes/api/saas/dl/order/queryOrderNodeSituation', 'get', params, callback);
//判断不选总床次颜色尺码是否汇报过
export const getQueryWorkTicketReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/queryWorkTicketReport', 'get', params, callback);
// 根据裁床id查询颜色尺码所对应所有菲票
export const getQueryByCutId = (params, callback) => req(path + '/mes/api/saas/cut/bed/queryByCutId', 'get', params, callback);


//*********************************************************  手动报工  *******************************************************//
// 手工报工节点完成
export const saveCompluteOrderNode = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/compluteOrderNode', 'patch', params, callback);
//查询色码明细表
export const getQuerynextNodeProcessNum = (params, callback) => req(path + '/mes/api/saas/dl/order/querynextNodeProcessNum', 'get', params, callback);



//*********************************************************  汇报记录  *******************************************************//
// 汇报记录
export const getOrderNodeReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport', 'get', params, callback);
// 删除汇报记录
export const deleteOrderNodeReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/deleteOrderNodeReport', 'delete', params, callback);
//根据id查询汇报记录详情
export const getOrderNodeReportById = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/' + params, 'get', null, callback);
//保存汇报记录
export const updateOrderNodeReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport', 'put', params, callback);


//********************************************************* 工资   *******************************************************//
//员工工资
export const getLayoutTotalDept = (params, callback) => req(path + '/mes/api/saas/sewn/layoutTotalDept', 'get', params, callback);
//工资详情
export const getLayoutTotal = (params, callback) => req(path + '/mes/api/saas/sewn/layoutTotal', 'get', params, callback);
//获取审核信息
export const getLayoutSubmitDept = (params, callback) => req(path + '/mes/api/saas/sewn/layoutSubmitDept', 'get', params, callback);
//提交
export const updateSewnConfirm = (params, callback) => req(path + '/mes/api/saas/sewn/sewnConfirm', 'post', params, callback);
//工资详情
export const getLayoutSubmit = (params, callback) => req(path + '/mes/api/saas/sewn/layoutSubmit', 'get', params, callback);
//主管查询组员记录
export const getLayoutDeptWages = (params, callback) => req(path + '/mes/api/saas/sewn/layoutDeptWages', 'get', params, callback);





//*********************************************************  裁床管理  *******************************************************//
// 裁床单查询
export const getSelectReduceBedListDl = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedListDl', 'get', params, callback);
// 花边明细或裁片明细
export const getColorSize = (params, callback) => req(path + '/mes/api/saas/dl/reduce/workTicket/' + params, 'get', null, callback);
//菲票明细
export const getWorkTicketFP = (params, callback) => req(path + '/mes/api/saas/dl/reduce/workTicketFP/' + params, 'get', null, callback);
//裁床单汇报
export const addChangeStatus = (params, callback) => req(path + '/mes/api/saas/dl/reduce/changeStatus', 'patch', params, callback);
// 拉布汇报
export const saveCuttingSheetReport = (params, callback) => req(path + '/mes/api/saas/dl/reduce/cuttingSheetReport', 'post', params, callback);



//*********************************************************  装箱管理  *******************************************************//

// 查询装箱单列表
export const getSelectReduceBedPacking = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedPacking', 'get', params, callback);
// 装箱详情
export const getselectReduceBedPackingDetails = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedPackingDetails', 'get', params, callback);
// 装箱详情删除
export const deleteReduceBedPackingDetails = (params, callback) => req(path + '/mes/api/saas/dl/reduce/deleteReduceBedPackingDetails', 'delete', params, callback);
//装箱删除
export const deleteReduceBedPacking = (params, callback) => req(path + '/mes/api/saas/dl/reduce/deleteReduceBedPacking', 'delete', params, callback);
// 新增查询(扫描菲票)
export const getworkTicket = (params, callback) => req(path + '/mes/api/saas/dl/reduce/workTicket', 'get', params, callback);
// 装箱新增
export const saveInsertReduceBedPacking = (params, callback) => req(path + '/mes/api/saas/dl/reduce/insertReduceBedPacking', 'post', params, callback);
//根据菲票id查询装箱数据
export const selectReduceBedPackingDetailsById = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedPackingDetailsById', 'get', params, callback);



//*********************************************************  供应商管理  *******************************************************//
// 获取供应商列表
export const getSupplierByPage = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/getSupplierByPage', 'get', params, callback);
// 根据供应商id查询信息
export const getSrmAllById = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/getCrmAllById', 'get', params, callback);
//保存供应商信息
export const updateSupplier = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/updateSrm', 'PATCH', params, callback);
//修改供应商状态
export const updaSrmStatus = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/updaCrmStatus', 'PATCH', params, callback);



//*********************************************************  客户管理  *******************************************************//
// 获取客户信息
export const getcrmCustoms = (params, callback) => req(path + '/ccm/api/saas/crmCustoms', 'get', params, callback);
// 根据供应商id查询信息
export const getCrmAllById = (params, callback) => req(path + '/ccm/api/saas/crmCustoms/getCrmAllById', 'get', params, callback);
//保存供应商信息
export const updateUpdateCrm = (params, callback) => req(path + '/ccm/api/saas/crmCustoms/updateUpdateCrm', 'PATCH', params, callback);
//修改供应商状态
export const updaCrmStatus = (params, callback) => req(path + '/ccm/api/saas/crmCustoms/updaCrmStatus', 'PATCH', params, callback);


//*********************************************************  外发管理  *******************************************************//
// 创建外发单
export const saveOutOrder = (params, callback) => req(path + '/mes/api/saas/outOrder', 'post', params, callback);
// 外发列表
export const getOutOrder = (params, callback) => req(path + '/mes/api/saas/outOrder/page', 'get', params, callback);
//根据id查询外发订单详情
export const getOutOrderById = (params, callback) => req(path + '/mes/api/saas/outOrder/' + params, 'get', null, callback);
//更新生产订单状态（接单和拒单）
export const updateaOrderStatus = (params, callback) => req(path + '/mes/api/saas/order', 'PUT', params, callback);


//*********************************************************  裁床收料 *******************************************************//
// 收料详情页
export const queryHanverstWorkTicket = (params, callback) => req(path + '/mes/api/saas/dl/reduce/queryHanverstWorkTicket', 'get', params, callback);
// 收料详情页-扫二维码
export const receivingScanning = (params, callback) => req(path + `/mes/api/saas/dl/reduce/receivingScanning/${params.id}`, 'get', params, callback);


//*********************************************************  品质检验 *******************************************************//
export const getPunchs = (params, callback) => req(path + '/ccm/api/saas/punch/punchs', 'post', params, callback);
// 查询任务
export const getBills = (params, callback) => req(path + '/tqm/api/saas/bills', 'get', params, callback);

export const getBillsID = (params, callback) => req(path + '/tqm/api/saas/bills/' + params, 'get', null, callback);

export const getByIds = (params, callback) => req(path + '/mes/api/saas/order/byIds?ids=' + params, 'get', null, callback);

export const getBoardsByWorkId = (params, callback) => req(path + '/tqm/api/saas/check/boardsByWorkId?workId=' + params, 'get', null, callback);

export const getStyleSizeMethods = (params, callback) => req(path + '/tqm/api/saas/standard/styleSizeMethods/', 'get', params, callback);

export const getBadReasonList = (params, callback) => req(path + '/tqm/api/saas/check/getBadReasonList', 'get', params, callback);

export const getStyleStandard = (params, callback) => req(path + '/tqm/api/saas/standard/styleStandard?lang=zh_CN&_t=15809645430&pageNum=1&pageSize=1000&workId=' + params, 'get', null, callback);

export const getTechnologyByBillCode = (params, callback) => req(path + '/pms/api/saas/pms/technologyByBillCode', 'get', params, callback);

export const getSaasOrder = (params, callback) => req(path + '/mes/api/saas/order/' + params, 'get', null, callback);

export const postBillProcesss = (params, callback) => req(path + '/tqm/api/saas/billProcesss', 'post', params, callback);

export const postState = (params, callback) => req(path + '/tqm/api/saas/bills/state', 'post', params, callback);

export const getBillProcesss = (params, callback) => req(path + '/tqm/api/saas/billProcesss/getById/' + params, 'get', null, callback);
//检验标准
export const SelectDictByType = (params, callback) => req(path + '/ccm/api/saas/basicBaseDicts/selectDictByType?type=crmpackagingMaterial', 'get', params, callback);

export const getByName = (params, callback) => req(path + '/tqm/api/saas/checkTypes/getByName?name=' + params, 'get', null, callback);


//*********************************************************  图片库 *******************************************************//
// 花型库列表接口
export const getPatternLibrary = (params, callback) => req(path + '/plm/api/saas/patternLibrary' + params, 'get', null, callback);
//花型库新增或者修改接口
export const postPatternLibrary = (params, callback) => req(path + '/plm/api/saas/patternLibrary', 'post', params, callback);
// 花型库查询详情接口
export const getPatternLibraryById = (params, callback) => req(path + '/plm/api/saas/patternLibrary/' + params, 'get', null, callback);
//图片素材分类
export const getTree = (params, callback) => req(path + '/plm/api/saas/group/tree?groupName=图片素材分类', 'get', params, callback);




//*********************************************************  领料管理 *******************************************************//
// 领料列表接口
export const getPickOrder = (params, callback) => req(path + '/mes/api/saas/pickOrder', 'get', params, callback);
// 新增领料单信息
export const postPickOrder = (params, callback) => req(path + '/mes/api/saas/pickOrder', 'post', params, callback);
// 修改领料单信息
export const patchPickOrder = (params, callback) => req(path + '/mes/api/saas/pickOrder', 'PATCH', params, callback);
// 根据ID查询领料单
export const getPickOrderById = (params, callback) => req(path + '/mes/api/saas/pickOrder/' + params, 'get', null, callback);
// 查询制造单的物料需求
export const getQueryMaterialNeed = (params, callback) => req(path + '/mes/api/saas/order/queryMaterialNeed', 'get', params, callback);
// 根据制造单编号查询当前每卷编号最大数
export const getQueryMaxReelNo = (params, callback) => req(path + '/mes/api/saas/pickOrder/queryMaxReelNo', 'get', params, callback);



//*********************************************************  松布管理 *******************************************************//
// 松布列表接口
export const selectLooseFabricData = (params, callback) => req(path + '/mes/api/saas/dl/order/selectLooseFabricData', 'get', params, callback);
// 根据ID查询领料单
export const selectLooseFabricDataById = (params, callback) => req(path + '/mes/api/saas/dl/order/selectLooseFabricDataById', 'get', params, callback);
// 查询制造单的物料需求
export const selectMaterialDataById = (params, callback) => req(path + '/mes/api/saas/dl/order/selectMaterialDataById', 'get', params, callback);
//修改松布数据
export const updateLooseFabricData = (params, callback) => req(path + '/mes/api/saas/dl/order/updateLooseFabricData', 'post', params, callback);
//新增松布数据
export const insertLooseFabricData = (params, callback) => req(path + '/mes/api/saas/dl/order/insertLooseFabricData', 'post', params, callback);
// 查询松布幅宽
export const selectLooseClothDetailsData = (params, callback) => req(path + '/mes/api/saas/dl/order/selectLooseClothDetailsData', 'get', params, callback);


//*********************************************************  拉布管理 *******************************************************//
// 拉布列表接口
export const getSpreadOrder = (params, callback) => req(path + '/mes/api/saas/spreadOrder', 'get', params, callback);
// 根据ID查询拉布单
export const getSpreadOrderById = (params, callback) => req(path + '/mes/api/saas/spreadOrder/' + params, 'get', null, callback);
// 根据制造单编号查询松布单物料明细
export const getQueryLooseCloth = (params, callback) => req(path + '/mes/api/saas/spreadOrder/queryLooseCloth', 'get', params, callback);
// 新增拉布单信息
export const postSpreadOrder = (params, callback) => req(path + '/mes/api/saas/spreadOrder', 'post', params, callback);
// 修改拉布单信息
export const patchSpreadOrder = (params, callback) => req(path + '/mes/api/saas/spreadOrder', 'PATCH', params, callback);

// 根据库位码查询库位
export const getWarehouseData = (params, callback) => req(path + '/mes/api/saas/order/getWarehouseData', 'get', params, callback);

export const updateLooseFabricWidthOfCloth = (params, callback) => req(path + '/mes/api/saas/dl/order/updateLooseFabricWidthOfCloth', 'get', params, callback);



//*********************************************************  QC管理 *******************************************************//
export const getCheckBillList = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBillList', 'get', params, callback);
export const getCheckBillTotalById= (params, callback) => req(path + '/tqm/api/saas/tqm/checkBillTotal', 'get', params, callback);
//根据制版单号带出尺寸表
export const getQueryPlateStyleSize= (params, callback) => req(path + '/pms/api/saas/v2/pms/queryPlateStyleSize', 'get', params, callback);
//根据订单编号跟工厂款号带出尺寸表
export const getQueryStyleSize= (params, callback) => req(path + '/pms/api/saas/bigGoodsBom/queryStyleSize', 'get', params, callback);



//获取疵点列表
export const getCheckDefectList = (params, callback) => req(path + '/tqm/api/saas/tqm/checkDefectList', 'get', params, callback);
//保存数据
export const saveCheckBill = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBill', 'post', params, callback);
//查询检验记录
export const getCheckBill = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBill', 'get', params, callback);
//打卡
export const saveClockIn = (params, callback) => req(path + '/tqm/api/saas/tqm/clockIn', 'post', params, callback);
//查询打卡列表
export const getClockInList = (params, callback) => req(path + '/tqm/api/saas/tqm/clockInList', 'get', params, callback);
//完成
export const changCheckBill = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBill?id='+params, 'patch', null, callback);


//*********************************************************  包装报工*******************************************************//
// 查询包装派工数据
export const getPackOrderDispatchApp = (params, callback) => req(path + '/mes/api/saas/pack/getPackOrderDispatchApp', 'get', params, callback);
// 查询包装派工详细数据
export const getPackOrderDispatchDetailApp = (params, callback) => req(path + '/mes/api/saas/pack/getPackOrderDispatchDetailApp', 'get', params, callback);
// 扫描包装派工菲票App
export const scanPackOrderDispatchApp = (params, callback) => req(path + '/mes/api/saas/pack/scanPackOrderDispatchApp', 'get', params, callback);
// 提交包装派工扫菲数据App
export const submitPackOrderDispatchApp = (params, callback) => req(path + '/mes/api/saas/pack/submitPackOrderDispatchApp', 'post', params, callback);




//*********************************************************  装箱报工*******************************************************//
//  装箱派工列表
export const selectEncaseDispatch = (params, callback) => req(path + '/mes/api/saas/encase/selectEncaseDispatch', 'get', params, callback);
// 装箱派工明细
export const encaseDispatchDetail = (params, callback) => req(path + '/mes/api/saas/encase/encaseDispatchDetail', 'get', params, callback);
// 装箱派工提交
export const workReport = (params, callback) => req(path + '/mes/api/saas/encase/workReport', 'post', params, callback);




//*********************************************************  制单进度 *******************************************************//
export const gewtSummaryProcedureNum = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/summaryProcedureNum', 'get', params, callback);


//*********************************************************  PDM审核列表 *******************************************************//
export const getAudit = (params, callback) => req(path + "/flowable/api/saas/task/todoList", "get", params, callback);
//通过审核
// export const approved = (params, callback) => req(path + '/aps/api/saas/audit/approved', 'post', params, callback);
export const approved = (params, callback) => req(path + `/flowable/api/saas/task/${params.type}?taskId=${params.taskId}&instanceId=${params.instanceId}&comment=${params.comment || ""}`, "post", null, callback);

export const getMapping = (params, callback) => req(path + '/aps/api/token/auditModule/mapping', 'GET', params, callback);


//*********************************************************  PDM样版任务*******************************************************//
export const getPatternMakingTaskList = (params, callback) => req(path + '/plm/api/saas/patternMaking/patternMakingTaskList', 'get', params, callback);
// 根据id查询详情
export const getPatternMakingDetail = (params, callback) => req(path + '/plm/api/saas/patternMaking/'+params, 'get', null, callback);
//获取裁剪人员列表
export const getAssignmentUser= (params, callback) => req(path + '/plm/api/saas/patternMaking/assignmentUser', 'post', params, callback);

export const getTeamUserList= (params, callback) => req(path + '/plm/api/saas/planning/getTeamUserList', 'get', params, callback);
//获取节点列表
export const getNodeStatusConfig= (params, callback) => req(path + '/plm/api/saas/patternMaking/getNodeStatusConfig', 'get', params, callback);
// 改变节点状态
export const nodeStatusChange= (params, callback) => req(path + '/plm/api/saas/patternMaking/nodeStatusChange', 'post', params, callback);
// 改变节点状态
export const handleNext= (params, callback) => req(path + '/plm/api/saas/patternMaking/next', 'get', params, callback);
// 获取素材信息
export const getAssociationMaterial= (params, callback) => req(path + '/plm/api/saas/material/getAssociationMaterial', 'post', params, callback);

// 确认收到样衣
export const receiveSample= (params, callback) => req(path + '/plm/api/saas/patternMaking/receiveSample', 'get', params, callback);

// 绑定样衣条码
export const setSampleBarCode= (params, callback) => req(path + '/plm/api/saas/patternMaking/setSampleBarCode', 'post', params, callback);


//*********************************************************  PDM样版任务*******************************************************//

//*********************************************************  PDM样衣管理*******************************************************//
// 样衣列表
export const getListBySampleItem = (params, callback) => req(path + "/plm/api/saas/sampleManager/getListBySampleItem", "get", params, callback);
// 样衣销售列表
// export const getSampleSaleList = (params, callback) => req(path + "/plm/api/saas/sampleManager/getSampleItemList", "post", params, callback);
export const getSampleSaleList = (params, callback) => req(path + "/plm/api/saas/sampleSale/getList", "get", params, callback);
// 获取客户
export const getCrmCustom = (params, callback) => req(path + '/ccm/api/saas/crmCustoms/getCrmCustom', 'get', params, callback);
//保存销售单
export const saveSampleSale = (params, callback) => req(path + '/plm/api/saas/sampleSale/save', 'post', params, callback);
// 根据i的查询样衣销售详情
export const getSampleSaleById = (params, callback) => req(path + '/plm/api/saas/sampleSale/'+params.id, 'get', params, callback);

// 样衣盘点列表
export const getSampleInventoryList = (params, callback) => req(path + "/plm/api/saas/sampleInventory/getList", "get", params, callback);
//样衣盘点详情
export const getSampleInventoryById = (params, callback) => req(path + "/plm/api/saas/sampleInventory/" + params, "get", null, callback);
//保存样衣盘点单
export const saveSampleInventory = (params, callback) => req(path + "/plm/api/saas/sampleInventory/save", "post", params, callback);
// 人员列表
export const getUserList = (params, callback) => req(path + "/amc/api/token/companyUser/users", "get", null, callback);
// 获取样衣管理类别
export const getSampleList = (params, callback) => req(path + "/plm/api/saas/sampleManager/getSampleItemList", "post", params, callback);
// 借出样衣
export const saveSampleBorrow = (params, callback) => req(path + "/plm/api/saas/sampleCirculate/borrow", "post", params, callback);
// 归还样衣详情
export const getSampleAlsoById = (params, callback) => req(path + "/plm/api/saas/sampleCirculate/getSampleReturnDetailsVO", "post", params, callback);
// 归还样衣
export const saveSampleAlso = (params, callback) => req(path + "/plm/api/saas/sampleCirculate/sampleReturn", "post", params, callback);
// 根据id查询样衣借出详情
export const getSampleReturnById = (params, callback) => req(path + "/plm/api/saas/sampleCirculate/getSampleReturnById?id="+params.id, "get", null, callback);
// 根据id查询样衣档案详情
export const getSampleManagerById = (params, callback) => req(path + "/plm/api/saas/sampleManager/"+params.id, "get", null, callback);


//*********************************************************  PDM评审会*******************************************************//
// 获取启用的会议类型列表
export const getReviewMeetingTypeList = (params, callback) => req(path + "/plm/api/saas/reviewMeetingType?status=1", "get", null, callback);
// 获取评审维度配置
export const getByDepartmentList = (params, callback) => req(path + "/plm/api/saas/reviewDimension/getByDepartment?ids=" + params, "get", null, callback);
// 获取部门人员
export const getPersonnelList = (params, callback) => req(path + "/amc/api/token/companyDept/querySecondMenu", "get", null, callback);
// 获取评审维度列表
export const getReviewDimensionList = (params, callback) => req(path + "/ccm/api/saas/basicBaseDicts/selectDictByTypes?type=reviewResults,reviewDimension", "get", null, callback);
// 获取设计款号&款式BOM列表
export const getDesignNoList = (params, callback) => req(path + "/plm/api/saas/packInfo", "get", params, callback);
// 保存评审会
// export const saveReviewMeeting = (params, callback) => req(path + "/plm/api/saas/reviewMeeting", "post", params, callback);
export const saveReviewMeeting = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/batchAdd", "post", params, callback);
// 获取评审会详情
export const getReviewMeetingById = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/" + params.id, "get", null, callback);
// 获取当前用户待参与的会议列表
export const getNeedMeMeeting = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/selectNeedMeMeeting", "get", params, callback);
// 获取会议总览列表
export const getReviewMeetingList = (params, callback) => req(path + "/plm/api/saas/reviewMeeting", "get", params, callback);
// 获取评审结果列表
export const getReviewResultList = (params, callback) => req(path + "/plm/api/saas/reviewResult/getByTypeId", "get", params, callback);
// 保存上传会议记录
export const saveStaffUpdate = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/staffUpdate", "post", params, callback);


//*********************************************************  工艺单*******************************************************//
/*获取工艺单*/
export const techSpecView = (params, callback) => req(path + "/plm/api/saas/techSpecView", "get", params, callback);

export const pdfHtml = (params, callback) => req(path + "/plm/api/saas/techSpecView/pdfHtml", "get", params, callback);


//********************************************************PDM设计成本*******************************************************//
// 查询设计成本列表
export const getStyleCost = (params, callback) => req(path + "/plm/api/saas/styleCost", "get", params, callback);
//根据id查询设计成本详情
export const getStyleCostById = (params, callback) => req(path + "/plm/api/saas/styleCost/"+params, "get", null, callback);
// 核价完成
export const pricingComplete = (params, callback) => req(path + "/plm/api/saas/styleCost/pricingComplete", "get", params, callback);
// 根据id查询部件库类型
export const queryShowComponent = (params, callback) => req(path + "/plm/api/saas/styleCost/queryShowComponent", "get", params, callback);
// 查询品类
export const getTreeByCode = (params, callback) => req(path + "/ccm/api/saas/basicStructure/treeByCode", "get", params, callback);
// 查询下级品类
export const getNextLevelList = (params, callback) => req(path + "/ccm/api/saas/basicStructure/nextLevelList", "get", params, callback);
// 查询部件类型
export const selectDictByTypes = (params, callback) => req(path + "/ccm/api/saas/basicDictDepends/selectDictByTypes", "get", params, callback);
// 新增部件类型
export const addShowComponent = (params, callback) => req(path + "/plm/api/saas/styleCost/addShowComponent", "post", params, callback);
// 根据部件id查询模板部件
export const getCostPage = (params, callback) => req(path + "/plm/api/saas/costTemplateComponent/costPage", "get", params, callback);
//保存部件信息
export const addStyleComponent = (params, callback) => req(path + "/plm/api/saas/styleCost/addStyleComponent", "post", params, callback);
// 删除左侧类别
export const deleteShowComponet = (params, callback) => req(path + "/plm/api/saas/styleCost/deleteShowComponet", "delete", params, callback);
// 修改部件信息
export const updateStyleComponent = (params, callback) => req(path + "/plm/api/saas/styleCost/updateStyleComponent", "patch", params, callback);

//********************************************************新版评审会议*******************************************************//
export const reviewStylePatternApp = (params, callback) => req(path + "/plm/api/saas/patternMaking/reviewStylePatternApp", "get", params, callback);
// 查询所有评审会议
export const getReviewMeeting = (params, callback) => req(path + "/plm/api/saas/reviewMeeting", "get", params, callback);
// 新增评审会议
export const addReviewMeeting = (params, callback) => req(path + "/plm/api/saas/reviewMeeting", "post", params, callback);
// 查询当前等待参加的会议
export const getSelectNeedMeMeeting = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/selectNeedMeMeeting", "get", params, callback);
// 根据id查询会议明细
export const getReviewMeetingByIdApp = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/reviewMeetingByIdApp?id="+params.id, "get",null , callback);
// 查询会议的款式信息
export const getQueryMeetingStyle= (params, callback) => req(path + "/plm/api/saas/reviewMeeting/queryMeetingStyle", "get", params, callback);
// 查询会议的引用信息
export const getQueryMeetingQuote= (params, callback) => req(path + "/plm/api/saas/reviewMeeting/queryMeetingQuote", "get", params, callback);
// 编辑会议款式信息的日销价格
export const editMeetingStylePrice = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/editMeetingStylePrice", "post", params, callback);
// 查询款式信息的各维度信息
export const getQueryStyleDimension= (params, callback) => req(path + "/plm/api/saas/reviewMeeting/queryStyleDimension", "get", params, callback);
// 查询所有的评审维度
export const getAll= (params, callback) => req(path + "/plm/api/saas/reviewDimensionReal/getAll", "get", null, callback);
// 根据部门id查询评审维度配置
export const getByDepartment= (params, callback) => req(path + "/plm/api/saas/reviewDimension/getByDepartment", "get", params, callback);
// 新增评语点
export const addComment = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/addComment", "post", params, callback);
// 编辑会议总价
export const editMeetingLogSummarize = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/editMeetingLogSummarize", "post", params, callback);
// 新增问题点
export const addProblem = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/addProblem", "post", params, callback);
// 会议跟进列表
export const getMeetingFollowUp= (params, callback) => req(path + "/plm/api/saas/reviewMeeting/meetingFollowUp", "get", params, callback);
// 查询会议跟进的款式信息详情
export const getQueryByStyleProblem= (params, callback) => req(path + "/plm/api/saas/reviewMeeting/queryByStyleProblem", "get", params, callback);
// 修改问题点
export const updateProblem = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/updateProblem", "post", params, callback);
// 修改评审会议
export const updateApp = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/updateApp", "post", params, callback);
// 修改评语点
export const updateComment = (params, callback) => req(path + "/plm/api/saas/reviewMeeting/updateComment", "post", params, callback);




//******************************************************** 移动审批 *******************************************************//
// 待办事项
export const getTaskTodoList = (params, callback) => req(path + '/plm/api/saas/task/todoList', 'get', params, callback)
// 已办事项
export const getTaskTodoFinishList = (params, callback) => req(path + '/plm/api/saas/task/finishedList', 'get', params, callback)
// 流程类型 - 字典
export const getBasicBaseDicts = (params, callback) => req(path + '/ccm/api/saas/basicBaseDicts/selectDictByTypes', 'get', params, callback);
// 批量审批
export const batchAuditTask = (params, callback) => req(path + `/flowable/api/saas/task/${params.type}?taskId=${params.taskId}&instanceId=${params.instanceId}&comment=${params.comment || '' }`, 'post', null, callback);
/* 使用业务编码查询流程信息 */
export const flowRecordBybusinessKey = (params, callback) => req(path + `/flowable/api/saas/task/flowRecordBybusinessKey`, 'get', params, callback);
/* 使用业务id审核 */
export const checkByBusinessKey = (params, callback) => req(path+'/flowable/api/saas/task/checkByBusinessKey', 'post', params, callback);
// 获取款式设计详情
export const styleDesignDetail = (params, callback) => req(path + '/plm/api/saas/style/' + params.businessKey, 'get', null, callback);
// 款式设计详情 - 物料信息
export const styleDesignMaterial = (params, callback) => req(path + '/plm/api/saas/style/bom', 'get', params, callback);
// 获取维度标签
export const queryDimensionLabelsByStyle = (params, callback) => req(path + '/plm/api/saas/style/queryDimensionLabelsByStyle', 'get', params, callback);
// 查询款式设计围度系数
export const queryCoefficientByStyle = (params, callback) => req(path + '/plm/api/saas/style/queryCoefficientByStyle', 'get', params, callback);

//*********************************************************  正确样*******************************************************//
export const styleColorCorrectInfo = (params,callback) => req(path + '/plm/api/saas/styleColorCorrectInfo/page','get', params, callback)
// 样衣看板 （根据样衣码获取设计款号）
export const getSampleBoardList = (params, callback) => req(path + '/plm/api/saas/patternMaking/sampleBoardList', 'get', params, callback);
// 根据设计款号获取款式配色（所有的大货款号）
export const getSampleStyleColorList = (params, callback) => req(path + '/plm/api/saas/styleColor/getSampleStyleColorList', 'get', params, callback);
// 根据设计款号获取样衣号
export const getSampleDressByStyleId = (params, callback) => req(path + '/plm/api/saas/patternMaking/getSampleDressByStyleId', 'get', params, callback);
export const saveCorrectBarCodeList = (params, callback) => req(path + '/plm/api/saas/styleColor/saveCorrectBarCodeList', 'post', params, callback);

//*********************************************************  素材库 - start *******************************************************//
// 获取个人文件夹列表
export const queryFileTree = (params, callback) => req(path + '/plm/api/saas/customFile/queryFileTree', 'get', params, callback);
// 素材库空间大小
export const spaceUsage = (params, callback) => req(path + '/plm/api/saas/material/spaceUsage', 'get', params, callback);
// 素材库下拉搜索
export const linkageQuery =  (params, callback) => req(path + '/plm/api/saas/material/linkageQuery', 'get', params, callback);
// 获取素材列表
export const getMaterialList = (params, callback) => req(path + '/plm/api/saas/material/listQuery', 'get', params, callback );
// 删除素材
export const delMaterial = (params, callback) => req(path + '/plm/api/saas/material/delByIds', 'delete', params, callback );
// 上传单个素材接口
export const addMateril = (params, callback) => req(path + '/plm/api/saas/material/add', 'post', params, callback);
// 上传多个素材接口
export const addMaterialList = (params, callback) => req(path + '/plm/api/saas/material/addList', 'post', params, callback);
// 收藏素材
export const addMaterialCollect = (params, callback) => req(path + '/plm/api/saas/materialCollect/add', 'post', params, callback);
// 取消收藏素材
export const delMaterialCollect = (params, callback) => req(path + '/plm/api/saas/materialCollect/del', 'delete', params, callback);
// 修改素材
export const editMaterial = (params, callback) => req(path + '/plm/api/saas/material/update', 'put', params, callback);
// 创建文件夹
export const addOrUpdateFile = (params, callback) => req(path + '/plm/api/saas/customFile/addOrUpdate', 'post', params, callback);
// 删除文件夹
export const delFolder= (params, callback) => req(path + '/plm/api/saas/customFile/del', 'get', params, callback);
// 合并文件夹
export const mergeFolder= (params, callback) => req(path + '/plm/api/saas/customFile/mergeFolder', 'post', params, callback);
// 批量提交 / 发布素材
export const materialBatchSubmit = (params, callback) => req(path + '/plm/api/saas/material/batchSubmit', 'put', params, callback);
// 批量修改素材
export const editMaterialList = (params, callback) =>  req(path + '/plm/api/saas/material/updateList','put', params, callback)
// 获取多个素材信息
export const listDetails = (params, callback) => req(path + '/plm/api/saas/material/listDetails?id='+params.ids, 'get', null, callback);
// 获取维度分类
export const queryMajorDimensionalityTree= (params, callback) => req(path + '/ccm/api/saas/basicMajorDimensionalityLabelTrees/queryMajorDimensionalityTree', 'get', params, callback);
// 获取部门来源人
export const getDepUser = (params, callback) => req(path + '/amc/api/token/virtualDept/getDepUser?name='+ params.name, 'get', null, callback);
// 启用/停用素材
export const materialAgentEnable = (params, callback) => req(path + '/plm/api/saas/material/agentEnable', 'post', params, callback);
// 获取品类列表
export const getStorehouseCategoryList = (params, callback) => req(path + '/ccm/api/saas/basicStructure/queryTree', 'get', params, callback);
// 用户组数据权限 - 创意素材库品牌
export const getByUserDataPermissionsAll = (params, callback) => req(path + '/amc/api/token/dataPermissions/getByUserDataPermissionsAll', 'get', params, callback);
// 获取标签
export const getTagsList = (params, callback) => req(path + '/ccm/api/saas/basicLabelUseScopes/getByMaterialId', 'get', params, callback);

//*********************************************************  素材库 - end *******************************************************//
// 获取正确样设计款号（fob）
export const sampleBoardList = (params, callback) => req(path + '/plm/api/saas/patternMaking/sampleBoardList', 'get', params, callback);
// 绑定正确样（fob）
export const patternMakingBarCode = (params, callback) => req(path + '/plm/api/saas/patternMakingBarCode', 'post', params, callback);
// 查询绑定的正确样（fob）
export const getPatternMakingBarCode = (params, callback) => req(path + '/plm/api/saas/patternMakingBarCode', 'get', params, callback);
// 检查是否已绑定（fob）
export const getPatternCheck = (params, callback) => req(path + '/plm/api/saas/patternMakingBarCode/check', 'get', params, callback);
// 查询绑定明细（fob）
export const getPatternDetail = (params, callback) => req(path + '/plm/api/saas/patternMakingBarCode/get', 'get', params, callback);
// 解除正确样绑定（fob）
export const delPattern = (params, callback) => req(path + '/plm/api/saas/patternMakingBarCode/remove', 'delete', params, callback);
// 审核正确样（fob）
export const approvalPattern = (params, callback) => req(path + '/plm/api/saas/patternMakingBarCode/status', 'post', params, callback);
// 查询绑定记录（fob）
export const getPatterLog = (params, callback) => req(path + '/plm/api/saas/patternMakingBarCode/log', 'get', params, callback);



//**************************************************新版打板任务******************************//
export const getStatusList = (params, callback) => req(path + '/plm/api/saas/processScheme/getStatusList', 'get', params, callback);
// 按钮权限
export const getQueryStatusInfoAndAction = (params, callback) => req(path + '/plm/api/saas/processBusinessInstance/queryStatusInfoAndAction', 'post', params, callback);
// 获取操作列表
export const getDoAction = (params, callback) => req(path + '/plm/api/saas/processBusinessInstance/doAction', 'post', params, callback);
// 字典管理
export const getSelectDictByTypes= (params, callback) => req(path + '/ccm/api/saas/basicDictDepends/selectDictByTypes', 'get', params, callback);
// 获取版师数据
export const getPatternDesignList= (params, callback) => req(path + '/plm/api/saas/patternMaking/getPatternDesignList', 'get', params, callback);
// 获取版房数据
export const getFindPRByPSId= (params, callback) => req(path + '/amc/api/token/team/findPRByPSId', 'get', params, callback);
// 挂起任务
export const getSuspend= (params, callback) => req(path + '/plm/api/saas/patternMaking/suspend', 'post', params, callback);
// 取消挂起
export const cancelSuspend= (params, callback) => req(path + '/plm/api/saas/patternMaking/cancelSuspend', 'get', params, callback);

//*********************************************新版采购单**************************************************************//
export const saveFlagOrder= (params, callback) => req(path + '/plm/api/saas/purchaseOrder/flagOrder', 'post', params, callback);
// 根据id查询详情
export const getPurchaseOrderById= (params, callback) => req(path + '/plm/api/saas/purchaseOrder/'+params.id, 'get', null, callback);
// 根据采购单id获取明细
export const getOrderStyleList= (params, callback) => req(path + '/plm/api/saas/purchaseOrder/getOrderStyleList', 'get', params, callback);
// 保存采购单
export const saveOrderStyleList= (params, callback) => req(path + '/plm/api/saas/purchaseOrder/update', 'post', params, callback);
// 获取仓库
export const getMaterialWarehouse= (params, callback) => req(path + '/plm/api/saas/materialWarehouse/queryAll', 'get', params, callback);
// 获取采购员
export const getDepts= (params, callback) => req(path + '/amc/api/token/companyDept/depts', 'get', params, callback);
// 查找供应商
export const getBasicsdatumSupplierList= (params, callback) => req(path + '/plm/api/saas/basicsdatumSupplier/getBasicsdatumSupplierList', 'get', params, callback);
// 审核
export const saveInitiateAudit= (params, callback) => req(path + '/plm/api/saas/purchaseOrder/initiateAudit', 'post', params, callback);
// 撤回审核
export const postCheckByBusinessKey= (params, callback) => req(path + '/flowable/api/saas/task/checkByBusinessKey', 'post', params, callback);

//*********************************************预约入库扫描start**************************************************************//
// 扫描单据
export const getOddNumberDetail= (params, callback) => req(path + '/aps/api/saas/outgoingProcessOrder/oddNumberDetail/'+params.oddNumber, 'get', null, callback);
// SKU扫码
export const postSku= (params, callback) => req(path + '/aps/api/saas/outgoingProcessOrder/getDetail/sku', 'get', params, callback);
// 入库仓库
export const getNormalWarehouses= (params, callback) => req(path + '/wms/api/saas/warehouse/normalWarehouses', 'get', params, callback);
// 保存
export const addWarehousingList= (params, callback) => req(path + '/pdm/api/saas/productionWarehousing/addWarehousingList', 'post', params, callback);
// 查询预约送货单列表
export const queryWarehousingList= (params, callback) => req(path + '/pdm/api/saas/productionWarehousing/queryWarehousingList', 'get', params, callback);
// 查询详情
export const queryWarehousingById= (params, callback) => req(path + '/pdm/api/saas/productionWarehousing/queryWarehousingById', 'get', params, callback);
// 提交
export const submitWarehousingList= (params, callback) => req(path + '/pdm/api/saas/productionWarehousing/submitWarehousingList?id='+params.id, 'POST', params, callback);
// 作废
export const voidWarehousingList= (params, callback) => req(path + '/pdm/api/saas/productionWarehousing/voidWarehousingList', 'DELETE', params, callback);
// 修改
export const updateWarehousing= (params, callback) => req(path + '/pdm/api/saas/productionWarehousing/updateWarehousing', 'post', params, callback);

//*********************************************预约入库扫描end**************************************************************//












